import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => [];

const onLoadData = (rawData) => (Array.isArray(rawData) ? rawData : []);

const { getStore, defaultStore } = createComponentStore({
  type: 'workflow_data',
  endpoint: 'workflow_data',
  registryKey: 'workflow_data',
  initData,
  onLoadData,
});

export const getWorkflowDataStore = getStore;
export default defaultStore;
